import { Component, OnInit, DestroyRef, inject } from "@angular/core";
import { takeUntilDestroyed } from "@angular/core/rxjs-interop";
import { ActivatedRoute, Router } from "@angular/router";
import { MatSnackBar } from "@angular/material/snack-bar";
import { Inject } from "@angular/core";
import {
  MatDialog,
  MatDialogRef,
  MAT_DIALOG_DATA,
} from "@angular/material/dialog";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import dayjs from "dayjs";

// Services
import { MsalService } from "@azure/msal-angular";
import { StoreUserService } from '@app/core/state/store-user.service';
import { StoreAuthService } from '@app/core/auth/store-auth.service';
import { DatabaseCacheService } from "../../../data/cache/database-cache.service";
import { UpdateSystemAdminService } from "../../../data/system-admin/update-system-admin.service";
import { InviteMembersService } from "../../../data/member/invite-members.service";
import {
  clearValidatorsExcept,
  resetFormUntouched,
  revalidateForm,
} from "../../../utils";
import { SHARED_IMPORTS } from "src/app/shared/standalone-imports";
import { SYSTEM_ADMIN_DETAILS_I18N } from "./system-admin-details.i18n";

@Component({
  selector: "app-system-admin-details",
  templateUrl: "./system-admin-details.component.html",
  styleUrls: ["./system-admin-details.component.css"],
  imports: SHARED_IMPORTS,
})
export class SystemAdminDetailsComponent implements OnInit {
  private readonly destroyRef = inject(DestroyRef);

  // i18n定数（型安全・IDE補完対応）
  protected readonly i18n = SYSTEM_ADMIN_DETAILS_I18N;

  public validId: boolean = false;
  public primaryAccount: boolean = false;

  public mode = SystemAdminDetailMode.disp;
  Mode = SystemAdminDetailMode;

  adminFormGroup: FormGroup;

  private readonly defaultSysAdminData: SysAdminData = {
    userId: "",

    lastName: "",
    firstName: "",
    name: "",

    roles: [],

    status: "",

    assignedDate: "--/--/--",

    lastModifiedAt: "--/--/--",
    lastModifiedBy: "--",
  };

  accountStatus = [
    { value: "OPEN", viewValue: SYSTEM_ADMIN_DETAILS_I18N.status.active },
    { value: "CLOSE", viewValue: SYSTEM_ADMIN_DETAILS_I18N.status.inactive },
  ];

  selectedStatus = "";
  selectedGroup = "";
  selectedRole = [];
  selectedPrivileges = [];

  accountManageRole = false;
  userManageRole = false;
  measureRole = false;
  referRole = false;

  adminData: SysAdminData;
  loginUserId: string;

  changesMade = false;

  constructor(
    public dialogRef: MatDialogRef<SystemAdminDetailsComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public _matdialog: MatDialog,
    public storeUser: StoreUserService,
    public storeAuth: StoreAuthService,
    private msalService: MsalService,
    private route: ActivatedRoute,
    private router: Router,
    public snackBar: MatSnackBar,
    public common: DatabaseCacheService,
    private updateSystemAdminService: UpdateSystemAdminService,
    private inviteMembersService: InviteMembersService,
  ) {}

  ngOnInit() {
    this.adminData = this.data?.sysAdminData ?? this.defaultSysAdminData;
    this.mode = this.data?.mode;
    // this.resetFields();

    this.route.params
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((params) => {
        let user = this.msalService.instance.getActiveAccount();
        this.loginUserId = user.idTokenClaims["sub"];
      });

    // 入力フォームのフィールド定義
    this.adminFormGroup = new FormGroup({
      lastName: new FormControl("", [Validators.required]),
      firstName: new FormControl("", [Validators.required]),
      userId: new FormControl(""),

      email: new FormControl("", [Validators.required, Validators.email]),

      assignedDate: new FormControl(""),

      status: new FormControl(""),
    });

    this.common.systemAdminRoles.forEach((role) =>
      this.adminFormGroup.addControl(role.code, new FormControl(false)),
    ); // 各roleに対してコントロールを追加

    this.adminFormGroup.disable();

    // 表示データ割り当て
    this.adminFormGroup.patchValue(this.adminData);
    this.adminData.roles.forEach((r) => {
      this.adminFormGroup.get(r).setValue(true);
    });

    // this.resetFields();

    if (this.mode == SystemAdminDetailMode.invite) {
      this.enableEdit();
    }

    resetFormUntouched(this.adminFormGroup);

    //
    this.route.params
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((params) => {
        // this.userId = this.data?.id;
        // this.sectionId = this.common.getSelectedSection().sectionId;
        // this.getStaff();
      });
  }

  // getStaff() {

  //   this.spinner.show("loaingStaff");

  //   this.resetFields();

  //   this.getUserAndBelongsService.getUserAndBelongs(this.userId).subscribe(
  //     res => {

  //       this.spinner.hide("loaingStaff");

  //       let resAny = (res as any);

  //       let userId = resAny.user.userId;

  //       if (userId === "ANONYMOUS") {
  //         this.snackBar.open("ERROR: invalid ID", null, {
  //           duration: 5000,
  //         });
  //       } else {
  //         this.staffData = {
  //           userId : resAny.user.userId,
  //           lastName: resAny.user.lastName ?? null,
  //           firstName: resAny.user.firstName ?? null,

  //           role : resAny.belongs.permissions.role,
  //           privileges : resAny.belongs.permissions.privileges,
  //           userType : resAny.belongs.permissions.userType,

  //           lastModifiedAt: resAny.belongs.commonInfo.lastModifiedAt,
  //           lastModifiedBy: resAny.belongs.commonInfo.lastModifiedBy,

  //           contractStartAt : dayjs(resAny.belongs.contractInfo.contractStartAt).isValid() ? dayjs(resAny.belongs.contractInfo.contractStartAt).format('YYYY/MM/DD') : null,
  //           contractEndAt : dayjs(resAny.belongs.contractInfo.contractEndAt).isValid() ? dayjs(resAny.belongs.contractInfo.contractEndAt).format('YYYY/MM/DD') : null,
  //           contractStatus : resAny.belongs.contractInfo.contractStatus.toUpperCase(),

  //           jobTitleCode : resAny.belongs.attributes?.jobTitleCode ?? 'OTHER',
  //         };

  //         // 読み込んだ値をフォームに反映
  //         this.adminFormGroup.patchValue(this.staffData);
  //         resAny.belongs.permissions.role.forEach(
  //           r => {
  //             this.adminFormGroup.get(r).setValue(true);
  //           }
  //         )

  //         this.selectedStatus = resAny.belongs.contractInfo.contractStatus.toUpperCase();
  //         // this.selectedGroup = convertedRes[0].permissions.userType.toUpperCase();
  //         this.validId = true;
  //       }
  //     },
  //     error => {
  //       this.spinner.hide("loaingStaff");
  //     }
  //   );
  // }

  onNoClick(): void {
    this.dialogRef.close();
  }

  // resetFields(): void {
  //   this.validId = false;
  //   this.selectedStatus = '';
  //   this.accountManageRole = false;
  //   this.userManageRole = false;
  //   this.measureRole = false;
  //   this.referRole = false;
  //   this.staffData = this.defaultAdminData;
  // }

  switchToEditMode() {
    this.mode = SystemAdminDetailMode.edit;

    this.enableEdit();
    return;
  }

  enableEdit() {
    // this.adminFormGroup.get("firstName").enable();
    // this.adminFormGroup.get("lastName").enable();
    this.adminFormGroup.get("email").enable();
    if (this.adminData.userId == this.loginUserId) {
      return; //自分自身の権限やステータスは変更できない
    }

    this.adminFormGroup.get("status").enable();

    this.common.systemAdminRoles.forEach((r) => {
      this.adminFormGroup.get(r.code).enable();
    });

    this.adminFormGroup.valueChanges
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(() => {
        this.changesMade = true;
      });

    return;
  }

  onEditOrUploadClicked() {
    // 現在がディスプレイモードなら編集モードに切り替える
    if (this.mode == SystemAdminDetailMode.disp) {
      this.switchToEditMode();
      return;
    }

    //そうでない場合はすでに編集モードなのでデータベースにアップロードする

    if (this.mode == this.Mode.edit) {
      // firstName と lastName が必須
      clearValidatorsExcept(this.adminFormGroup, ["firstName", "lastName"]);
      // this.adminFormGroup.get('email')?.clearValidators();
    }
    if (this.mode == this.Mode.invite) {
      // email が必須
      clearValidatorsExcept(this.adminFormGroup, ["email"]);
      // this.adminFormGroup.get('firstName')?.clearValidators();
      // this.adminFormGroup.get('lastName')?.clearValidators();
    }

    revalidateForm(this.adminFormGroup); // ValidationRuleを現在の設定で再適用

    //　各フィールドにValidationRuleを適用し確認
    this.adminFormGroup.markAllAsTouched();
    this.adminFormGroup.updateValueAndValidity();
    if (!this.adminFormGroup.valid) {
      let snack = this.snackBar.open(
        this.i18n.validation.checkFields,
        this.i18n.button.close,
        {
          duration: 30000,
        },
      );
      return;
    }

    var postParams: Record<string, any> = {};

    postParams.userId = this.adminData.userId;

    postParams.firstName =
      this.adminFormGroup.value.firstName != ""
        ? this.adminFormGroup.value.firstName
        : null;
    postParams.lastName =
      this.adminFormGroup.value.lastName != ""
        ? this.adminFormGroup.value.lastName
        : null;

    postParams.status = this.adminFormGroup.value.status;

    postParams.adminType = "SYSTEM_ADMIN";
    postParams.email = this.adminFormGroup.value.email;

    var roles = [];
    this.common.systemAdminRoles.forEach((r) => {
      if (this.adminFormGroup.value[r.code]) {
        roles.push(r.code);
      }
    });
    if (roles.length > 0) {
      postParams.roles = roles; //UpdateAdmin では rolesになっている
      postParams.role = roles; //InviteMember では role になっている
    } else {
      let snack = this.snackBar.open(
        this.i18n.validation.selectRole,
        this.i18n.button.close,
        {
          duration: 30000,
          panelClass: ["snackbar-center"],
        },
      );
      return;
    }

    if (this.mode == this.Mode.edit) {
      this.updateSystemAdmin(postParams);
    }

    if (this.mode == this.Mode.invite) {
      this.inviteSystemAdmin(postParams);
    }
  }

  async updateSystemAdmin(postParams) {
    try {
      this.updateSystemAdminService
        .updateSystemAdmin(this.adminData.userId, postParams)
        .pipe(takeUntilDestroyed(this.destroyRef))
        .subscribe((res) => {

          let snack = this.snackBar.open(
            this.i18n.message.updateSuccess,
            this.i18n.button.close,
            {
              duration: 30000,
            },
          );
          snack
            .afterDismissed()
            .pipe(takeUntilDestroyed(this.destroyRef))
            .subscribe(() => {
              this.dialogRef.close();
              this.router.navigate(["/system-admin/"]).then(() => {
                this.router.navigate(["/system-admin/", "admins"]);
              });
            });
        });
    } catch (e) {
      let snack = this.snackBar.open(
        this.i18n.message.updateError,
        this.i18n.button.close,
        {
          duration: 30000,
        },
      );
      snack
        .afterDismissed()
        .pipe(takeUntilDestroyed(this.destroyRef))
        .subscribe(() => {
          this.dialogRef.close();
        });
    }
  }

  async inviteSystemAdmin(postParams) {
    this.inviteMembersService
      .inviteMembers(null, postParams)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe({
        next: (res) => {

          let snack = this.snackBar.open(
            this.i18n.message.inviteSuccess,
            this.i18n.button.close,
            {
              duration: 30000,
            },
          );
          snack
            .afterDismissed()
            .pipe(takeUntilDestroyed(this.destroyRef))
            .subscribe(() => {
              this.dialogRef.close();
            });
        },
        error: (e) => {
          let snack = this.snackBar.open(
            this.i18n.message.inviteError,
            this.i18n.button.close,
            {
              duration: 30000,
            },
          );
          snack
            .afterDismissed()
            .pipe(takeUntilDestroyed(this.destroyRef))
            .subscribe(() => {
              this.dialogRef.close();
            });
        },
      });
  }
}
export interface KeyValue {
  key: string;
  value: string;
}

export interface InUpdateMember {
  userType: string;
  role: string[];
  privileges: KeyValue[];
  contractStatus: string;
}

export namespace AccountManagementPrivileges {
  export namespace CREATE_ACCOUNT {
    export const key = "ACCOUNT";
    export const value = "CREATE";
  }
  export namespace READ_ACCOUNT {
    export const key = "ACCOUNT";
    export const value = "READ";
  }
  export namespace UPDATE_ACCOUNT {
    export const key = "ACCOUNT";
    export const value = "UPDATE";
  }
  export namespace DELETE_ACCOUNT {
    export const key = "ACCOUNT";
    export const value = "DELETE";
  }
}

export enum SystemAdminDetailMode {
  disp,
  edit,
  invite,
}

export interface SysAdminData {
  userId: string;

  lastName: string;
  firstName: string;
  name: string;

  roles: string[];
  status: string;
  assignedDate: string;

  lastModifiedAt: string;
  lastModifiedBy: string;
}
